const initialHistoryLength = window.history ? window.history.length : 0;
const account = {
        name: 'account',
        trigger: $('.js-trigger-account'),
        elem: $('.js-target-account'),
        active: false,
        disabled: 'cxs',
        callback: false
    },
    languagesHeader = {
        name: 'languagesHeader',
        trigger: $('.js-trigger-languages-header'),
        elem: $('.js-target-languages-header'),
        active: false,
        disabled: false,
        callback: {
            show: function () {
                $('.js-languages-header').addClass('is-active');

                bLazy.revalidate();
            },
            hide: function () {
                $('.js-languages-header').removeClass('is-active');
            }
        }
    },
    languagesAside = {
        name: 'languagesAside',
        trigger: $('.js-trigger-languages-aside'),
        elem: $('.js-target-languages-aside'),
        active: false,
        disabled: false,
        keepActive: true,
        callback: {
            show: function () {
                $('.js-languages-aside').addClass('is-active');

                bLazy.revalidate();
            },
            hide: function () {
                $('.js-languages-aside').removeClass('is-active');
            }
        }
    },
    minicart = {
        name: 'minicart',
        trigger: $('.js-trigger-minicart'),
        elem: $('.js-target-minicart'),
        active: false,
        disabled: 'cxs;xs',
        callback: {
            show: function () {
                if (!checkResolution('cxs;xs')) {
                    window.scrollTo(0, 0);
                }
            }
        }
    },
    search = {
        trigger: $('.js-trigger-search'),
        elem: $('.js-target-search'),
        overlay: true,
        active: false,
        callback: {
            show: function () {
                $('.js-target-search').find('.c-form__input').trigger('focus');
                $('.header').addClass('has-active-search');
            },
            hide: function () {
                $('.header').removeClass('has-active-search');
            }
        }
    },
    aside = {
        name: 'aside',
        trigger: $('.js-trigger-aside'),
        elem: $('.js-content-aside'),
        active: false,
        overlay: true,
        disabled: false,
    },
    nav = {
        name: 'nav',
        trigger: $('.js-trigger-nav'),
        elem: $('.js-target-nav'),
        active: false,
        overlay: true,
        disabled: false
    };

function toggleSubnav(trigger) {
    const id = $(trigger).data('id');

    $(trigger).siblings('.is-active').removeClass('is-active');
    $(trigger).addClass('is-active');

    $('.js-content-subnav.is-active').removeClass('is-active');
    $('.js-content-subnav[data-id="' + id + '"]').addClass('is-active');
}

function closeSubnav(trigger) {
    const id = $(trigger).data('id');

    $('.js-content-subnav[data-id="' + id + '"]').removeClass('is-active');
    $('.js-trigger-subnav.is-active').removeClass('is-active');
}

$(function () {
    const clickableElements = [languagesHeader, languagesAside, account, minicart, search, aside, nav];

    for (const object of clickableElements) {
        object.trigger.on('click', function (event) {
            if (!object.disabled || (object.disabled && !checkResolution(object.disabled))) {
                event.preventDefault();

                toggleElem(object);
            }
            else {
                hideElem(object);
            }
        });
    }

    $('body').on('click', function (event) {
        if (activeElement && activeElement.active) {
            if (!$(event.target).closest(activeElement.elem).length && !$(event.target).closest(activeElement.trigger).length) {
                if (activeElement.name == 'nav') {
                    //hideNav();
                } else {
                    hideElem(activeElement);
                }
            }
        }
    });

    $('.js-target-languages-header > a').on('click', function () {
        hideElem(languagesHeader);
    });

    $('.js-target-account > a').on('click', function () {
        hideElem(account);
    });

    $('.js-close-minicart').on('click', function () {
        hideElem(minicart);
    });

    $('.js-close-search').on('click', function () {
        hideElem(search);
    });

    $('.js-close-nav').on('click', function () {
        hideElem(nav);
    });

    $('.js-trigger-subnav').on('click', function (e) {
        e.preventDefault();

        toggleSubnav(this);
    });

    $('.js-close-subnav').on('click', function (e) {
        e.preventDefault();

        closeSubnav(this);
    });

    $('.js-trigger-products-nav').on('click', function (e) {
        e.preventDefault();

        $('.js-target-products-nav').addClass('is-active');
    });

    $('.js-close-products-nav').on('click', function (e) {
        e.preventDefault();

        $('.js-target-products-nav').removeClass('is-active');
    });

    if (initialHistoryLength > 1) {
        $('.js-breadcrumb-back').addClass('is-loaded');
    } else {
        $('.js-breadcrumb-holder').addClass('without-back');
    }

    $('.js-breadcrumb-back').on('click', function(e) {
        const currentHistoryLength = window.history.length;

        e.preventDefault();

        window.history.go(initialHistoryLength - currentHistoryLength - 1);
    });
});
